import { render, staticRenderFns } from "./ProductServiceEditor.vue?vue&type=template&id=d6644f06&scoped=true"
import script from "./ProductServiceEditor.vue?vue&type=script&lang=js"
export * from "./ProductServiceEditor.vue?vue&type=script&lang=js"
import style0 from "./ProductServiceEditor.vue?vue&type=style&index=0&id=d6644f06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6644f06",
  null
  
)

export default component.exports